import { cn } from "../../../../../utils/classnames";
import { getImageFocusStyle, IMAGE_FOCUS_CLASS } from "../../serviceImages";

/**
 * The two photos that introduce a sub-service. They stay side by side at every
 * width — the design keeps the pair intact on mobile, just shorter.
 *
 * @param images - two SERVICE_IMAGES entries with an `alt` added:
 *   [{ src, focusX, focusY, alt }, { ... }]
 */
export const ImagePair = ({ images, className }) => (
  <div className={cn("tw:grid tw:grid-cols-2 tw:gap-2 tw:lg:gap-3", className)}>
    {images.map((image) => (
      <img
        key={image.src}
        src={image.src}
        alt={image.alt}
        style={getImageFocusStyle(image)}
        className={cn(
          "tw:w-full tw:h-[145px] tw:lg:h-[320px] tw:object-cover tw:rounded-[8px]",
          IMAGE_FOCUS_CLASS
        )}
      />
    ))}
  </div>
);
